import { render } from "./Tabs.vue?vue&type=template&id=156405d8"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=156405d8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__